import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const reverseTransform = nationality => ({ ...removeExtraSubFieldsHelper(nationality, ['picture']) });

export { reverseTransform };
